<template>
  <div>
    <div v-if="editPrograma && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmitPrograma" v-if="!editPrograma || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!editPrograma || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Situação" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                <el-option :key="false" label="INATIVO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Tipo do recurso" prop="tipo_recurso" :rules="[$requiredChange]" key="tipo_recurso">
              <el-select v-model="dados.tipo_recurso">
                <el-option label="CAPITAL" value="capital"></el-option>
                <el-option label="CUSTEIO" value="custeio"></el-option>
                <el-option label="AMBOS" value="ambos"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Órgão responsável" prop="orgao_responsavel" key="orgao_responsavel">
              <el-input v-model="dados.orgao_responsavel" maxlength="191" v-on:blur="formatData('orgao_responsavel')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="4" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-programa" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    editPrograma: false,
    dados: {
      id: '',
      nome: '',
      descricao: '',
      orgao_responsavel: '',
      tipo_recurso: 'ambos',
      ativo: true,
    }
  }),
  methods: {
    getProgramaById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/programa/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => { this.dados = JSON.parse(JSON.stringify(response.data)) })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmitPrograma () {
      document.getElementById("btn-programa").focus()

      this.$refs.dados.validate((valid) => {
        if (valid) {
          window.eventBus.$emit('loading', true)

          if (this.editPrograma) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/programa/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitPrograma')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          } else {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/programa/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitPrograma')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          }
        } else {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        }
      })
    },
    formatData (field) {
      if (!this.dados[field]) return false
      this.dados[field] = this.dados[field].toUpperCase()
      this.dados[field] = this.$removerAcentos(this.dados[field])
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getProgramaById(value)
          this.editPrograma = true
        }
      }
    }
  }
}
</script>

